import enHk from './en_hk';
import enId from './en_id';
import enMy from './en_my';
import enSg from './en_sg';
import en from './en';
import jaJp from './ja_jp';
import koKr from './ko_kr';
import thTh from './th_th';
import zhHk from './zh_hk';
import zhTw from './zh_tw';

export default {
  en_hk: enHk,
  en_id: enId,
  en_my: enMy,
  en_sg: enSg,
  en,
  ja_jp: jaJp,
  ko_kr: koKr,
  th_th: thTh,
  zh_hk: zhHk,
  zh_tw: zhTw,
};



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/data/lines/index.js